import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {sortBy} from 'lodash';

function Array(props){
    const[arr, setArray] = useState([]);
    useEffect(()=>{
            axios.get(`https://pixabay.com/api/?key=15489555-318fcca1200a48f374a1ce3ea&q=${props.s}&image_type=photo&pretty=true`)
            .then(response=>{
                let temp = [];
                temp.push(...response.data.hits);
                props.appSort!=='none'?setArray(sortBy(temp,props.appSort)):setArray(temp)})
            .catch(error=>console.log(error));
        },[props.s, props.appSort]);
    return(
        <div  className="row g-0">{arr.map(item => (

            <div key={item.id} className="col-12 col-sm-10 col-md-9 mx-auto col-lg-6 p-2 card">
                <div className="row g-0 bg-light">
                    <div className="col col-lg-4 pixa h-100" style={{backgroundImage:`url(${item.largeImageURL})`}}></div>
                <div className="col col-lg-8 h-100">
                    <div className="card-body">
                    <h5 className="card-title fw-bold">{item.tags}</h5>
                    <div className="card-text"><p>Likes: {item.likes}</p>
                    <p>Views: {item.views}</p></div>
                    <a href={item.pageURL} className="btn btn-outline-info">More Info</a></div></div></div>
            </div>
        ))}
        </div>
    )
}

export default Array